// extracted by mini-css-extract-plugin
export default {"PageSideBar":"PageSideBar_PageSideBar__gWmtc","PageSideBar__inner":"PageSideBar_PageSideBar__inner__MNpmG"};